import PropTypes from "prop-types"
import React from "react"

const colorMap = {
  info: "#6fcbef",
  video: "#6fcbef",
  warning: "#eeb456",
  danger: "#dc8686",
  success: "#65bd0d",
}

const iconShape = {
  circle: <circle cx="17" cy="17" r="15" strokeWidth="4" />,
  triangle: <path d="M19 4.1L3.41 32H34.59L19 4.1z" strokeWidth="4" />,
  square: <path d="M2 2h30v30H2z" strokeWidth="4" />,
  video: null,
}

const iconFill = (content, type) => {
  switch (content) {
    case "warning":
      return (
        <text
          fontFamily="FiraSans-Black, Fira Sans"
          fontSize="19"
          fontWeight="700"
          fill={colorMap[type]}
        >
          <tspan x="12.798" y="24">
            ?
          </tspan>
        </text>
      )
    case "danger":
      return (
        <g strokeWidth="4">
          <path d="M12 12l9.68 10.193L12 12z" />
          <path d="M21.68 12L12 22.193 21.68 12z" />
        </g>
      )
    case "success":
      return (
        <g transform="matrix(-1 0 0 1 34 0)" strokeWidth="4">
          <path d="M9 12l9.68 10.193L9 12z" />
          <path d="M23.11 14.76l-6.914 7.28 6.914-7.28z" />
        </g>
      )
    case "diagonal":
      return (
        <g strokeWidth="4">
          <path d="M27 6.193l-19 20 19-20z" />
        </g>
      )
    case "exclamation":
      return (
        <text
          fontFamily="FiraSans-Black, Fira Sans"
          fontSize="19"
          fontWeight="700"
          fill={colorMap[type]}
        >
          <tspan x="16.5" y="27">
            !
          </tspan>
        </text>
      )
    case "info":
    default:
      return (
        <text
          fontFamily="FiraSans-Black, Fira Sans"
          fontSize="18"
          fontWeight="700"
          fill={colorMap[type]}
        >
          <tspan x="14.462" y="24">
            i
          </tspan>
        </text>
      )
  }
}

const AlertIcon = ({ type, width, shape, content }) => {
  const properContent = content === null ? type : content
  const properIcon =
    type === "video" ? (
      <span className="m-r-20">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 67.8 43.9"
          width="76px"
          height="100%"
        >
          <path
            d="M65 0H2.8C1.3 0 0 1.2 0 2.8v38.3c0 1.5 1.2 2.8 2.8 2.8H65c1.5 0 2.8-1.2 2.8-2.8V2.8C67.8 1.3 66.6 0 65 0zM35.9 27.4L26.2 33V10.9l19.4 11-9.7 5.5z"
            fill="#3372b9"
          />
        </svg>
      </span>
    ) : (
      <span className="m-r-10">
        <svg
          width={shape === "triangle" && width === "34px" ? "40px" : width}
          height="34px"
          viewBox="0 0 34 34"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke={colorMap[type]} fill="none" fillRule="evenodd">
            {iconShape[shape]}
            {iconFill(properContent, type)}
          </g>
        </svg>
      </span>
    )
  return properIcon
}

AlertIcon.propTypes = {
  type: PropTypes.oneOf(["info", "warning", "danger", "success", "video"]),
  content(props) {
    if (
      ![
        "info",
        "danger",
        "exclamation",
        "diagonal",
        "success",
        "warning",
        "video",
      ].includes(props.content) &&
      props.content !== null
    ) {
      return new Error("Failed prop content!")
    }

    if (
      (props.shape === "triangle" && props.content !== "exclamation") ||
      (props.shape === "circle" &&
        (props.content === "exclamation" || props.content === "video")) ||
      (props.shape === "square" &&
        (props.content === "diagonal" ||
          props.content === "exclamation" ||
          props.content === "video"))
    ) {
      return new Error("Failed prop content for chosen shape!")
    }

    return undefined
  },
  shape: PropTypes.oneOf(["triangle", "circle", "square"]),
  width: PropTypes.string,
}

AlertIcon.defaultProps = {
  type: "info",
  content: null,
  shape: "circle",
  width: "34px",
}

export default AlertIcon
